import { useI18n } from '../i18n/LocaleContext'
import { cn } from '../lib/cn'
import { getProduct } from '../config'

/** The product's own mark (ProductConfig.LogoMark), drawn inline so it scales crisply. */
export function LogoMark({ size = 32, className }: { size?: number; className?: string }) {
  const Mark = getProduct().LogoMark
  return <Mark size={size} className={cn('shrink-0', className)} />
}

export function Logo({
  size = 32,
  onDark,
  className,
}: {
  size?: number
  /** Light wordmark for the ink rail and the auth hero. */
  onDark?: boolean
  className?: string
}) {
  const { t } = useI18n()
  return (
    <span className={cn('flex items-center gap-2', className)}>
      <LogoMark size={size} />
      <span
        className={cn(
          'font-display text-[21px] tracking-tightish',
          onDark ? 'text-gray-50' : 'text-gray-900',
        )}
      >
        {t.brand.name}
      </span>
    </span>
  )
}
